import CLIENT from '../utils/restClient';
import Logger, { LOG_LEVELS } from '../utils/log';

export const MODULE_NAME = 'COUNTRIESONHOLD_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
    return MODULE_NAME + '.' + name;
}

const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');
const UNLOCKED_OK = namespaced('UNLOCKED_OK');
const UNLOCKED_FAIL = namespaced('UNLOCKED_FAIL');
const LOCKED_OK = namespaced('LOCKED_OK');
const LOCKED_FAIL = namespaced('LOCKED_FAIL');

export const ACTION_TYPES = {
    LOAD,
    LOAD_OK,
    LOAD_FAIL,
    UNLOCKED_OK,
    UNLOCKED_FAIL,
    LOCKED_OK,
    LOCKED_FAIL,
};

export const updateSubStateFromAction = (state = { data: undefined, loading: false, error: null, uploading: false }, action = {}) => {
    log.debug('updateSubStateFromAction: ', action, state);
    const getNewState = (action, state) => {
        switch (action.type) {
            case LOAD:
                return Object.assign({}, state, { loading: true, error: null });
            case LOAD_OK:
                return Object.assign({}, state, { data: action.response, loading: false, error: null });
            case LOAD_FAIL:
                return Object.assign({}, state, { data: undefined, loading: false, error: action.error });
            case UNLOCKED_OK: {
                const countriesOnHold = [...state.data.data];

                if (action.lockType === 'Financial' || action.lockType === 'Both') {
                    countriesOnHold.find((country) => country.countryCode === action.countryCode).onHold.financialDataOnHoldFrom = '';
                }

                if (action.lockType === 'Logistical' || action.lockType === 'Both') {
                    countriesOnHold.find((country) => country.countryCode === action.countryCode).onHold.logisticalDataOnHoldFrom = '';
                }

                return Object.assign({}, state, { data: { data: countriesOnHold }, loading: false, error: null });
            }
            case UNLOCKED_FAIL:
                return Object.assign({}, state, { data: undefined, loading: false, error: action.error });
            case LOCKED_OK: {
                const countriesOnHold = [...state.data.data];

                if (action.lockType === 'Financial' || action.lockType === 'Both') {
                    countriesOnHold.find((country) => country.countryCode === action.countryCode).onHold.financialDataOnHoldFrom = action.lockDate;
                }

                if (action.lockType === 'Logistical' || action.lockType === 'Both') {
                    countriesOnHold.find((country) => country.countryCode === action.countryCode).onHold.logisticalDataOnHoldFrom = action.lockDate;
                }

                return Object.assign({}, state, { data: { data: countriesOnHold }, loading: false, error: null });
            }
            case LOCKED_FAIL:
                return Object.assign({}, state, { data: undefined, loading: false, error: action.error });
            default:
                return state;
        }
    };
    const newState = getNewState(action, state);
    log.debug('updateSubStateFromAction:  newState', newState);
    return newState;
};

export const API = {
    doGetCountriesOnHold: (startAt, count) => {
        return (dispatch) => {
            log.debug('doGetCountriesOnHold()');
            dispatch({ type: LOAD });
            return CLIENT.getCountriesOnHold(startAt, count, true)
                .then((response) => {
                    log.debug('doGetCountriesOnHold(): response: ', response);
                    dispatch({ type: LOAD_OK, response: response });
                })
                .catch((error) => {
                    log.debug('doGetCountriesOnHold(): error: ', error);
                    dispatch({ type: LOAD_FAIL, error: error });
                });
        };
    },

    doRemoveCountryOnHoldLock: (countryCode, lockType, callback) => {
        return (dispatch) => {
            log.debug('doRemoveCountryOnHoldLock()');
            dispatch({ type: LOAD });
            return CLIENT.removeCountryOnHoldLock(countryCode, lockType)
                .then((response) => {
                    log.debug('doRemoveCountryOnHoldLock(): response: ', response);
                    dispatch({ type: UNLOCKED_OK, countryCode: countryCode, lockType: lockType });
                    callback(response);
                })
                .catch((error) => {
                    log.debug('doRemoveCountryOnHoldLock(): error: ', error);
                    dispatch({ type: UNLOCKED_FAIL, error: error });
                    callback(error);
                });
        };
    },

    doAddCountryOnHoldLock: (countryCode, lockType, lockDate, callback) => {
        return (dispatch) => {
            log.debug('doAddCountryOnHoldLock()');
            dispatch({ type: LOAD });
            return CLIENT.addCountryOnHoldLock(countryCode, lockType, lockDate)
                .then((response) => {
                    log.debug('doAddCountryOnHoldLock(): response: ', response);
                    dispatch({ type: LOCKED_OK, countryCode: countryCode, lockType: lockType, lockDate });
                    callback(response);
                })
                .catch((error) => {
                    log.debug('doAddCountryOnHoldLock(): error: ', error);
                    dispatch({ type: LOCKED_FAIL, error: error });
                    callback(error);
                });
        };
    },
};

export default API;
